import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useIdleTimer } from 'react-idle-timer';
import useModalContext from 'components/context/modal';

import dataApi from '../api/data';

// 15 min interval
const INTERVAL_MS = 15 * 60 * 1000;

const AppVersion = props => {
  const buildIdRef = useRef(props.buildId);
  const isIdleRef = useRef(false);

  const modalContext = useModalContext();

  useIdleTimer({
    timeout: INTERVAL_MS,
    onIdle: () => {
      isIdleRef.current = true;
    },
    onActive: () => {
      isIdleRef.current = false;
    },
    debounce: 500,
  });

  const startVersionChecking = () => {
    const intervalId = setInterval(() => {
      (async () => {
        const { data, error } = await dataApi.getAppStatus();
        if (error) {
          console.error("We can't fetch app status.");
          return;
        }

        if (!data.buildId) {
          console.error("API doesn't return buildId.");
          return;
        }

        if (!props.supportedUrls.find(url => window.location.pathname.indexOf(url) === 0)) {
          // dont show dialog on current url
          return;
        }

        if (isIdleRef.current === false) {
          // dont show dialog to active user
          return;
        }

        // when app has no initial buildId - it's weird, propably old version
        if (buildIdRef.current !== data.buildId) {
          clearInterval(intervalId);
          modalContext.confirm(
            <>
              A new version of the {props.appName} website is available. Please refresh the page to
              ensure you&apos;re using the latest version.
              <br />
              <br />
              You will not lose any of your edits or saved work in this project.
            </>,
            {
              title: `${props.appName} has an update`,
              cancelLabel: 'Remind Me Later',
              onCancel: () => {
                startVersionChecking();
              },
              confirmLabel: 'Refresh Now',
              onConfirm: () => {
                window.location.reload();
              },
            },
          );
        }
      })();
    }, INTERVAL_MS);

    return intervalId;
  };

  useEffect(() => {
    const intervalId = startVersionChecking();
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  // TODO render as html comment
  return <div dangerouslySetInnerHTML={{ __html: `<!-- ${props.appName}:${props.buildId} -->` }} />;
};

AppVersion.propTypes = {
  supportedUrls: PropTypes.array,
  buildId: PropTypes.string,
  appName: PropTypes.string,
};

AppVersion.defaultProps = {
  supportedUrls: [],
};

export default AppVersion;
